<template>
    <!-- 推广明细 -->
    <ZhaiHeadPC class="zhai-head" />

    <div class="container errong">
        <!-- 顶部条 -->
        <div class="shengse mt-2">
            <div class="dixian px-3 py-2 top-bar-pc">
                <div class="left lf go-back" @click="goBack">
                    <i class="fa fa-bullhorn"></i> 推广中心
                </div>
            </div>
        </div>

        <!-- 主体 -->
        <div class="pd-body">
            <div class="pd-shell">
                <!-- 页头 -->
                <div class="page-head">
                    <div class="ph-left">
                        <div class="ph-title">推广明细</div>
                        <div class="ph-sub">查看推广产生的收入与支出记录</div>
                    </div>

                    <div class="ph-right">
                        <button class="btn-soft" @click="goMyWallet">
                            <i class="fa fa-rmb"></i> 我的钱包
                        </button>
                        <button class="btn-soft" @click="goWithdraw">
                            <i class="fa fa-credit-card"></i> 申请提现
                        </button>
                    </div>
                </div>

                <!-- 过滤条：Tab(全部/收入/支出) + 统计 -->
                <div class="filter-bar">
                    <div class="tabs">
                        <button class="tab-btn" :class="{ active: activeTab === 'all' }" @click="changeTab('all')">全部</button>
                        <button class="tab-btn" :class="{ active: activeTab === 'in' }" @click="changeTab('in')">收入</button>
                        <button class="tab-btn" :class="{ active: activeTab === 'out' }" @click="changeTab('out')">支出</button>
                    </div>

                    <div class="stat">
                        <span class="stat-item">记录：<b>{{ total }}</b></span>
                        <span class="stat-split"></span>
                        <span class="stat-item">
              本页合计：
              <b :class="{ plus: pageSum > 0, minus: pageSum < 0 }">{{ sumText }}</b>
            </span>
                    </div>
                </div>

                <!-- 表格卡片 -->
                <div class="table-card">
                    <!-- Loading -->
                    <div v-if="loading" class="state-line">
                        <span class="text">加载中…</span>
                    </div>

                    <!-- Error -->
                    <div v-else-if="errorMsg" class="state-line error">
                        <span class="text">加载失败：{{ errorMsg }}</span>
                        <button class="chip ghost" @click="fetchList()">重试</button>
                    </div>

                    <!-- Empty -->
                    <div v-else-if="pagedList.length === 0" class="empty-line">
                        <span class="line"></span>
                        <span class="text">暂无内容</span>
                        <span class="line"></span>
                    </div>

                    <!-- Data -->
                    <div v-else class="table-layout">
                        <!-- 表头 -->
                        <div class="thead-wrap" :style="{ paddingRight: scrollbarWidth + 'px' }">
                            <table class="pd-table">
                                <colgroup>
                                    <col style="width: 58%" />
                                    <col style="width: 12%" />
                                    <col style="width: 12%" />
                                    <col style="width: 18%" />
                                </colgroup>
                                <thead>
                                <tr>
                                    <th style="padding-right:40%!important;">明细</th>
                                    <th>类型</th>
                                    <th class="th-right">金额</th>
                                    <th>时间</th>
                                </tr>
                                </thead>
                            </table>
                        </div>

                        <!-- 表体滚动 -->
                        <div class="tbody-wrap" ref="tbodyWrap" @scroll="onBodyScroll">
                            <table class="pd-table">
                                <colgroup>
                                    <col style="width: 58%" />
                                    <col style="width: 12%" />
                                    <col style="width: 12%" />
                                    <col style="width: 18%" />
                                </colgroup>

                                <tbody>
                                <template v-for="item in pagedList" :key="item.id">
                                    <!-- 主行 -->
                                    <tr class="main-row" @click="toggleExpand(item.id)">
                                        <td class="td-detail">
                                            <div class="detail-main">
                                                <button class="exp-btn" type="button" @click.stop="toggleExpand(item.id)">
                                                    <span class="caret" :class="{ open: isExpanded(item.id) }">▶</span>
                                                </button>

                                                <div class="detail-text">
                                                    <div class="title-line">
                                                        <span class="title" :title="displayTitle(item)">{{ displayTitle(item) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- ✅ 类型：优先后端 type(in/out)，兜底 amount 正负 -->
                                        <td class="td-type">
                        <span class="type-pill" :class="typeClass(displayType(item))">
                          {{ displayType(item) === "out" ? "支出" : "收入" }}
                        </span>
                                        </td>

                                        <!-- ✅ 金额：按 type 强制正负，避免“支出却显示+” -->
                                        <td class="td-money">
                        <span class="money" :class="{ plus: displayAmount(item) > 0, minus: displayAmount(item) < 0 }">
                          {{ formatMoney(displayAmount(item)) }}
                        </span>
                                        </td>

                                        <td class="td-time">{{ item.time || "—" }}</td>
                                    </tr>

                                    <!-- 展开行 -->
                                    <tr v-if="isExpanded(item.id)" class="expand-row">
                                        <td colspan="4" class="expand-td">
                                            <div class="expand-panel">
                                                <div class="kv-grid">
                                                    <div class="kv" v-if="item.orderAmount != null">
                                                        <div class="k">订单金额</div>
                                                        <div class="v">{{ Number(item.orderAmount).toFixed(2) }} 元</div>
                                                        <div class="a"></div>
                                                    </div>

                                                    <div class="kv" v-if="item.orderNo">
                                                        <div class="k">订单号</div>
                                                        <div class="v mono" :title="item.orderNo">{{ item.orderNo }}</div>
                                                        <div class="a">
                                                            <button class="copy-btn" @click="copyText(item.orderNo)">复制</button>
                                                        </div>
                                                    </div>

                                                    <div class="kv" v-if="item.remark">
                                                        <div class="k">备注</div>
                                                        <div class="v" :title="item.remark">{{ item.remark }}</div>
                                                        <div class="a"></div>
                                                    </div>

                                                    <div class="kv" v-if="item.tags && item.tags.length">
                                                        <div class="k">标签</div>
                                                        <div class="v">{{ item.tags.join(" / ") }}</div>
                                                        <div class="a"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>

                        <!-- 分页 -->
                        <div class="pager-wrap" v-if="totalPages > 1">
                            <div class="pager">
                                <button class="pager-btn" :disabled="page === 1 || pageChanging" @click="goPage(page - 1)">«</button>

                                <button class="pager-btn" :class="{ active: page === 1 }" :disabled="pageChanging" @click="goPage(1)">1</button>

                                <template v-if="totalPages >= 3">
                                    <template v-if="page > 1 && page < totalPages">
                                        <button class="pager-btn dots" disabled>…</button>
                                        <button class="pager-btn active" disabled>{{ page }}</button>
                                        <button class="pager-btn dots" disabled>…</button>
                                    </template>
                                    <template v-else>
                                        <button class="pager-btn dots" disabled>…</button>
                                    </template>
                                </template>

                                <button class="pager-btn" :class="{ active: page === totalPages }" :disabled="pageChanging" @click="goPage(totalPages)">
                                    {{ totalPages }}
                                </button>

                                <button class="pager-btn" :disabled="page === totalPages || pageChanging" @click="goPage(page + 1)">»</button>
                            </div>

                            <div class="pager-loading" v-if="pageChanging">加载中…</div>
                        </div>
                    </div>
                </div>

                <div class="gray-gap"></div>
            </div>
        </div>
    </div>

    <div class="gongxi2"></div>
    <ZhaiFootPC />
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import { mapGetters } from "vuex";
    import http from "../utils/http.js";

    export default {
        name: "PPromotionDetails",
        components: { ZhaiHeadPC, ZhaiFootPC },

        data() {
            return {
                activeTab: "all",

                list: [],
                total: 0,

                page: 1,
                pageSize:10,

                loading: false,
                pageChanging: false,
                errorMsg: "",

                reqSeq: 0,
                expandedMap: Object.create(null),
                scrollbarWidth: 0,
                currentUserId: null,
            };
        },

        computed: {
            ...mapGetters(["getUser"]),

            totalPages() {
                const t = Number(this.total || 0);
                const s = Number(this.pageSize || 12);
                return Math.max(1, Math.ceil(t / s));
            },

            pagedList() {
                return Array.isArray(this.list) ? this.list : [];
            },

            // ✅ 合计必须按 displayAmount 算，否则“支出正数”会把合计算错
            pageSum() {
                return this.pagedList.reduce((sum, x) => sum + Number(this.displayAmount(x) || 0), 0);
            },

            sumText() {
                const v = Number(this.pageSum || 0);
                const abs = Math.abs(v).toFixed(2);
                if (v > 0) return `+${abs}`;
                if (v < 0) return `-${abs}`;
                return "0.00";
            },
        },

        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        mounted() {
            const token = localStorage.getItem("token");
            if (!token) {
                this.$router.replace("/login");
                return;
            }

            this.currentUserId = this.resolveUserIdSafe();
            this.fetchList();

            this.$nextTick(() => {
                this.calcScrollbarWidth();
                window.addEventListener("resize", this.calcScrollbarWidth, { passive: true });
            });
        },

        beforeUnmount() {
            window.removeEventListener("resize", this.calcScrollbarWidth);
        },

        methods: {
            // ====== ✅ 关键：后端筛选参数 ======
            mapFlowForApi(frontTab) {
                const t = (frontTab || "all").toLowerCase();
                if (t === "in") return "in";
                if (t === "out") return "out";
                return "all";
            },

            // 你页面没有直推/间推按钮，先固定 all
            mapTabForApi() {
                return "all";
            },

            // ====== ✅ 类型：优先后端 type ======
            displayType(item) {
                if (!item) return "in";
                const t = String(item.type || "").toLowerCase();
                if (t === "in" || t === "out") return t;

                // 兜底：没有 type 就用 amount 正负
                const a = Number(item.amount);
                if (!Number.isFinite(a)) return "in";
                return a < 0 ? "out" : "in";
            },

            // ====== ✅ 金额：按 type 强制正负 ======
            displayAmount(item) {
                if (!item) return 0;
                let a = Number(item.amount);
                if (!Number.isFinite(a)) a = 0;

                const t = this.displayType(item);
                if (t === "out") return -Math.abs(a);
                return Math.abs(a);
            },

            // ====== UI ======
            calcScrollbarWidth() {
                const el = this.$refs.tbodyWrap;
                if (!el) return;
                const w = el.offsetWidth - el.clientWidth;
                this.scrollbarWidth = w > 0 ? w : 0;
            },

            displayTitle(item) {
                // ✅ 后端若已给 title，直接用（最准确）
                if (item && item.title) return item.title;

                // 兜底拼接
                const who = item && item.fromUser ? `直推客户 ${item.fromUser}` : "直推客户";
                const typeText = item && item.typeText ? item.typeText : (this.displayType(item) === "out" ? "支出" : "收入");
                const tags = Array.isArray(item && item.tags) ? item.tags : [];
                const product = tags.find(t => t && !["佣金", "直推", "间推", "收入", "支出"].includes(t)) || "";
                const prodText = product ? ` 购买 #${product}#` : "";
                return `${who}${prodText} ${typeText}`;
            },

            onBodyScroll() {},

            goBack() {
                if (window.history.length > 1) window.history.back();
                else window.location.href = "/Promotion";
            },
            goMyWallet() {
                if (this.$router) this.$router.push("/MyWallet");
                else window.location.href = "/MyWallet";
            },
            goWithdraw() {
                if (this.$router) this.$router.push("/WalletWithdrawal");
                else window.location.href = "/WalletWithdrawal";
            },

            toggleExpand(id) {
                if (this.$set) this.$set(this.expandedMap, id, !this.expandedMap[id]);
                else this.expandedMap[id] = !this.expandedMap[id];
                this.$nextTick(this.calcScrollbarWidth);
            },
            isExpanded(id) {
                return !!this.expandedMap[id];
            },

            async changeTab(tab) {
                if (this.activeTab === tab) return;
                this.activeTab = tab;
                this.page = 1;
                this.expandedMap = Object.create(null);
                await this.fetchList();
            },

            async goPage(p) {
                const pageNum = Number(p);
                if (!pageNum || pageNum < 1 || pageNum > this.totalPages) return;
                if (pageNum === this.page) return;
                if (this.pageChanging) return;

                this.pageChanging = true;
                this.page = pageNum;
                this.expandedMap = Object.create(null);

                await this.fetchList(true);
                this.pageChanging = false;
            },

            // ✅ 请求后端（核心：带 flow）
            async fetchList(isPaging = false) {
                const seq = ++this.reqSeq;
                if (!isPaging) this.loading = true;
                this.errorMsg = "";

                try {
                    const params = {
                        tab: this.mapTabForApi(),                 // all/direct/indirect
                        flow: this.mapFlowForApi(this.activeTab), // all/in/out ✅
                        page: this.page,
                        pageSize: this.pageSize,
                    };
                    if (this.currentUserId) params.userId = this.currentUserId;

                    const res = await http.get("/platform/withdraw/promoDetail", params);
                    const json = res && res.data ? res.data : null;

                    if (seq !== this.reqSeq) return;

                    if (!json || json.status !== 1) {
                        this.errorMsg = (json && json.msg) || "接口返回异常";
                        this.list = [];
                        this.total = 0;
                        return;
                    }

                    const d = json.data || {};
                    this.list = Array.isArray(d.list) ? d.list : [];
                    this.total = Number(d.total || 0);

                    this.$nextTick(this.calcScrollbarWidth);
                } catch (e) {
                    if (seq !== this.reqSeq) return;
                    this.errorMsg = e && e.message ? e.message : "网络错误";
                    this.list = [];
                    this.total = 0;
                } finally {
                    if (seq === this.reqSeq) this.loading = false;
                }
            },

            // ===== 小工具 =====
            formatMoney(val) {
                const num = Number(val || 0);
                const abs = Math.abs(num).toFixed(2);
                if (num > 0) return `+${abs}`;
                if (num < 0) return `-${abs}`;
                return "0.00";
            },
            typeClass(t) {
                return { in: t === "in", out: t === "out" };
            },

            async copyText(text) {
                try {
                    if (navigator.clipboard && navigator.clipboard.writeText) {
                        await navigator.clipboard.writeText(String(text));
                    } else {
                        const input = document.createElement("input");
                        input.value = String(text);
                        document.body.appendChild(input);
                        input.select();
                        document.execCommand("copy");
                        document.body.removeChild(input);
                    }
                    window.alert("已复制");
                } catch (e) {
                    console.error(e);
                }
            },

            resolveUserIdSafe() {
                const u = this.getUser || {};
                if (u && u.id) return u.id;

                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                return null;
            },
        },
    };
</script>


<style scoped>
    /* ✅ 这里保持你原来的 style 不变（我直接把你贴的整段原样保留） */

    /* 基础 */
    .fa { margin-right: 6px; }
    .lf { font-weight: 900; }
    .gongxi2 { height: 20px; }
    .errong { padding-left: 30px; padding-right: 30px; }
    .go-back { cursor: pointer; }
    @media (min-width: 768px) {
        .zhai-head { position: fixed; top: 0; width: 100%; z-index: 1000; }
        .errong { margin-top: 80px; }
    }

    /* 顶部栏 */
    .top-bar-pc { display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; }
    .top-bar-pc .left { display: inline-flex; align-items: center; font-size: 15px; color: #333; }
    .top-bar-pc .left:active { opacity: 0.75; }

    /* 主体壳 */
    .pd-body { background: #f3f4f6; border-radius: 2px; margin-top: 10px; }
    .pd-shell { max-width: 1200px; margin: 0 auto; }

    /* 页头 */
    .page-head {
        display: flex; align-items: center; justify-content: space-between; gap: 12px;
        padding: 14px; background: #fff; border: 1px solid #eee; border-radius: 2px;
    }
    .ph-title { font-size: 16px; font-weight: 900; color: #111; }
    .ph-sub { margin-top: 6px; font-size: 13px; color: #888; }
    .ph-right { display: flex; gap: 10px; flex-wrap: wrap; }
    .btn-soft {
        height: 36px; padding: 0 12px; border-radius: 2px;
        border: 1px solid #eee; background: #fafafa;
        font-size: 13px; cursor: pointer; color: #333;
        display: inline-flex; align-items: center;
    }
    .btn-soft .fa { margin-right: 8px; color: #00c26f; }
    .btn-soft:active { opacity: 0.8; }

    /* 过滤条 */
    .filter-bar {
        margin-top: 10px; display: flex; align-items: flex-start; gap: 12px;
        padding: 10px 12px; background: #fff; border: 1px solid #eee; border-radius: 2px;
        flex-wrap: wrap;
    }
    .tabs { display: inline-flex; gap: 8px; }
    .tab-btn {
        height: 34px; padding: 0 14px; border-radius: 2px;
        border: 1px solid #e9e9e9; background: #fff;
        font-size: 13px; cursor: pointer; color: #333;
    }
    .tab-btn.active { border-color: #ff4d4f; color: #ff4d4f; background: #fff6f6; font-weight: 900; }
    .tab-btn:active { opacity: 0.85; }

    .stat {
        margin-left: auto; display: inline-flex; align-items: center; gap: 10px;
        font-size: 13px; color: #666;
    }
    .stat b { color: #111; font-weight: 900; }
    .stat .plus { color: #00c26f; }
    .stat .minus { color: #ff4d4f; }
    .stat-split { width: 1px; height: 14px; background: #e9e9e9; display: inline-block; }

    /* 表格卡片 */
    .table-card {
        margin-top: 12px; background: #fff; border: 1px solid #eee; border-radius: 2px;
        box-shadow: 0 6px 16px rgba(0,0,0,.04);
        overflow: hidden;
        height: 62vh; min-height: 420px; max-height: 680px;
    }
    .table-layout { height: 100%; display: flex; flex-direction: column; }

    /* ✅ 表头容器：右侧补滚动条宽度 */
    .thead-wrap {
        flex-shrink: 0;
        background: #fafafa;
        border-bottom: 1px solid #eee;
    }

    /* ✅ 表体容器：只有这里滚动 */
    .tbody-wrap {
        flex: 1;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        background: #fff;
    }

    /* 表格公共 */
    .pd-table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        min-width: 980px;
    }

    /* 统一盒模型避免差异 */
    .pd-table th,
    .pd-table td {
        box-sizing: border-box;
        padding: 12px 14px;
        font-size: 13px;
    }

    .pd-table thead th {
        text-align: center;
        color: #666;
        font-weight: 900;
        background: #fafafa;
    }

    .th-right { text-align: right; }

    .pd-table tbody td {
        text-align: center;
        border-bottom: 1px solid #f2f2f2;
        color: #333;
        vertical-align: middle;
    }
    .pd-table tbody tr:hover { background: #fcfcfc; }

    /* 主行 */
    .main-row { cursor: pointer; }
    .td-money { text-align: right; font-weight: 900; white-space: nowrap; }
    .money.plus { color: #00c26f; }
    .money.minus { color: #ff4d4f; }
    .td-time { color: #666; white-space: nowrap; }

    .type-pill {
        display: inline-flex; align-items: center; justify-content: center;
        height: 28px; min-width: 64px;
        padding: 0 10px; border-radius: 2px;
        font-size: 12px; font-weight: 900;
        border: 1px solid transparent;
    }
    .type-pill.in { color: #1f8a4c; background: #e9fff1; border-color: #b7eb8f; }
    .type-pill.out { color: #cf1322; background: #fff1f0; border-color: #ffccc7; }

    /* 明细主行内部 */
    .detail-main { display: flex; align-items: center; gap: 10px; }
    .exp-btn {
        width: 28px; height: 28px; border-radius: 2px;
        border: 1px solid #eee; background: #fff;
        cursor: pointer; flex-shrink: 0;
        display: inline-flex; align-items: center; justify-content: center;
    }
    .exp-btn:active { opacity: 0.8; }
    .caret { display: inline-block; font-size: 12px; transition: transform .15s ease; color: #666; }
    .caret.open { transform: rotate(90deg); }

    .detail-text { min-width: 0; flex: 1; }
    .title-line { display: flex; align-items: center; gap: 10px; min-width: 0; }
    .title {
        font-size: 14px; font-weight: 900; color: #111;
        min-width: 0;
        overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    }

    /* 展开行 */
    .expand-row td { vertical-align: top; }
    .expand-td { padding: 0 14px 14px; background: #fff; }
    .expand-panel {
        border: 1px solid #f1f1f1;
        border-radius: 2px;
        background: #fafafa;
        padding: 12px;
    }

    /* KV */
    .kv-grid { display: grid; gap: 10px; }
    .kv {
        display: grid;
        grid-template-columns: 88px 1fr auto;
        gap: 12px;
        align-items: center;
        padding: 8px 10px;
        background: #fff;
        border: 1px solid #f0f0f0;
        border-radius: 2px;
    }
    .k { font-size: 12px; color: #9aa0a6; font-weight: 900; }
    .v {
        font-size: 12px; color: #6b7280;
        min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    }
    .mono {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    }
    .copy-btn {
        border: 0;
        background: #f4f4f5;
        color: #333;
        font-size: 12px;
        padding: 6px 10px;
        border-radius: 10px;
        cursor: pointer;
    }
    .copy-btn:active { opacity: 0.75; }

    /* 状态/空 */
    .state-line {
        height: 100%;
        padding: 26px 12px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9b9b9b;
        font-size: 14px;
        gap: 10px;
    }
    .state-line.error { color: #cf1322; }
    .chip {
        height: 28px;
        padding: 0 10px;
        border-radius: 2px;
        border: 1px solid #e9e9e9;
        background: #fff;
        font-size: 12px;
        cursor: pointer;
        color: #333;
    }
    .chip.ghost { background: #fafafa; }

    .empty-line {
        height: 100%;
        padding: 26px 12px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9b9b9b;
        font-size: 14px;
    }
    .empty-line .line { width: 140px; height: 1px; background: #e9e9e9; margin: 0 14px; }
    .empty-line .text { white-space: nowrap; }

    /* 分页固定底部 */
    .pager-wrap {
        flex-shrink: 0;
        padding: 12px 0 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-top: 1px solid #f2f2f2;
        background: #fff;
    }
    .pager {
        display: inline-flex;
        align-items: center;
        border-radius: 2px;
        overflow: hidden;
        border: 1px solid #e6e6e6;
        background: #fff;
    }
    .pager-btn {
        min-width: 34px;
        height: 32px;
        padding: 0 10px;
        border: 0;
        border-right: 1px solid #e6e6e6;
        background: #fff;
        color: #333;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }
    .pager-btn:last-child { border-right: 0; }
    .pager-btn:disabled { opacity: 0.45; cursor: not-allowed; }
    .pager-btn.active { color: #00c26f; font-weight: 900; background: #f3fff8; }
    .pager-btn.dots { cursor: default; font-weight: 900; }
    .pager-btn:active:not(:disabled):not(.dots) { opacity: 0.75; }
    .pager-loading { margin-top: 6px; font-size: 12px; color: #9a9a9a; }

    .gray-gap { height: 26px; }
</style>
